import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { MenuController, ViewWillEnter, ViewDidLeave, ViewDidEnter } from '@ionic/angular';
import { GtrakAuthService } from '../../services/gtrak-auth.service';
import { AuthCreds, LoginMode } from '../../../../common/rest-api/models/login-creds';
import { ToasterService } from '../../../../../app/common/services/toaster.service';
import { RequestParams } from '../../../../common/rest-api/models/request-params';
import { NavController } from '@ionic/angular';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-login-page',
  templateUrl: 'login.page.html',
  styleUrls: [
    './login.page.scss'
  ]
})
export class LoginPage implements ViewWillEnter, OnInit, ViewDidLeave, ViewDidEnter {

  LoginMode = LoginMode;

  userId: string;
  password: string;

  stopNumber: string;
  lockerNumber: string;
  lastName: string;
  isQRCode: boolean = false;
  forDate: string;
  isServiceOffline: boolean = false;

  passedInMode: boolean = false;

  routeCode: string;

  routeListParams: RequestParams;
  QRCodeURL: string;
  loginMode: LoginMode = LoginMode.Gtrak;
  creds: AuthCreds = new AuthCreds();
  loaded: boolean = false;
  showOptionsBar: boolean = true;
  @HostListener('document:keydown.enter', ['$event'])
  handleEnterKey(event: KeyboardEvent) {
    this.submit();
  }
  constructor(
    private router: Router,
    public menu: MenuController,
    public authService: GtrakAuthService,
    private toastr: ToasterService,
    private navController: NavController,

  ) {

  }

  async ngOnInit(): Promise<void> {
    //setInterval(async () => {
      const isActive = await this.authService.IsGallagherServiceActive();
      this.isServiceOffline = !isActive;
   // }, 5000);

    const url: string = this.router.url;
    this.QRCodeURL = environment.QRCodeURL;
    if (this.authService.isNative) {
      this.loginMode = LoginMode.Gmobile;
      this.showOptionsBar = false;
    } else {
      if (url.includes('login')) {
        this.loginMode = LoginMode.Gtrak;
        this.showOptionsBar = false;
      } else if (url.includes('mobile')) {
        this.loginMode = LoginMode.Gmobile;
        this.showOptionsBar = false;
      } else if (url.includes('wearer')) {
        this.loginMode = LoginMode.GWearer;
        this.showOptionsBar = false;
      }
      this.loaded = true;
    }

    const mode: any = this.router.getCurrentNavigation()?.extras?.state?.mode;

    if (mode) {
      this.loginMode = mode as LoginMode;
      this.passedInMode = true;
    }

    this.routeListParams = new RequestParams();
    this.routeListParams.setOrdering('Description', 'asc');
    this.routeListParams.setPaging(1, 0);

    this.creds.routeCode = '1';
    this.creds.routeDate = this.getCurrentDayFormatted();
  }

  // Disable side menu for this page
  ionViewWillEnter(): void {
    const originalLoginMode = Number(localStorage.getItem('loginMode') ?? '-1');
    if (this.authService.isAuthenticated && !this.passedInMode && (originalLoginMode === this.loginMode)) {
      this.router.navigate([this.authService.user?.homeLocation]);

    }
  }

  ionViewDidEnter(): void {
    this.menu.enable(false);
  }

  // Restore to default when leaving this page
  ionViewDidLeave(): void {
    this.menu.enable(true);
  }

  changeLoginForm(mode: LoginMode): void {
    this.loginMode = mode;
    this.isQRCode = false;
  }

  selectRoute(data): void {
    this.creds.routeCode = data.detail.value;
  }

  async submit(): Promise<void> {
    // Clear fields based on login mode,

    this.creds.prepareForLoginMode(this.loginMode);
    this.loaded = false;
    if ((!this.creds.password || (this.creds.password.length === 0) || !this.creds.login || (this.creds.login.length === 0)) &&
      ((this.loginMode === LoginMode.Gtrak) || (this.loginMode === LoginMode.Groute) || (this.loginMode === LoginMode.Gmobile))) {
      this.toastr.presentToast('danger', '', 'Invalid Username or Password', 1000);
    } else if ((!this.creds.lockerNum || (this.creds.lockerNum.length === 0) || !this.creds.lastName || (this.creds.lastName.length === 0) ||
      !this.creds.stopCode || (this.creds.stopCode.length === 0)) && (this.loginMode === LoginMode.GWearer)) {
      this.toastr.presentToast('danger', '', 'Invalid Stop Code, Locker Number, and Last Name', 1000);
    } else {
      var status = await this.authService.Login(this.creds);

      if (this.authService.isNative && !this.authService?.user?.canAccessMobileApp) {
        this.toastr.presentToast('danger', '', 'Not a valid mobile login!', 1000);
      } else {
        if (status) {
          var medium = this.getPlatform();
          this.authService.SaveUserAccessLog(this.creds.login, medium, "Cust");

          localStorage.setItem('loginMode', this.loginMode.toString());
          // TODO Potentially employ a switch for the three different modes
          if (this.authService.isNative || (this.loginMode === LoginMode.Gmobile && this.authService.user.isEmployeeUser) || (this.authService.user.isEmployeeUser)) {
            this.authService.setUser(null);
            this.router.navigate(['/mobile']);
          } else if (this.loginMode === LoginMode.Groute || this.authService.user.isDriver) {
            this.toastr.presentToast('danger', "You can't log in to the app. Please contact the administrator.", "Unauthorized access to the driver");
          } else {

            this.authService.setUser(this.authService.user);
            this.router.navigate(['/home']);
          }

        } else if (status) {
          this.toastr.presentToast('danger', "You can't log in to the app. Please contact the administrator.", "Unauthorized access to the driver");
        }
        else {
          this.toastr.presentToast('danger', 'The credentials provided are not valid.', 'Invalid Credentials');
        }

      }
    }
    this.loaded = true;
  }

  navigateToBaseLogin(): void {
    var url = 'auth';

    if (this.loginMode === LoginMode.Gmobile) {
      url += '/mobile';
    } else if (this.loginMode === LoginMode.GWearer) {
      url += '/wearer';
    } else if (this.loginMode === LoginMode.Groute) {
      url += '/route';
    } else {
      url += '/login';
    }

    this.navController.navigateRoot([url]);
  }

  navigateToCreateAccount(): void {
    this.navController.navigateRoot(['auth/login/create-account']);
  }

  navigateToForgotPassword(): void {
    this.navController.navigateRoot(['auth/login/forgot-password']);
  }
  scanBarCode(): void {

    this.navController.navigateForward(['auth/login/scan-barcode']);
  }
  navigateToQRCode(): void {
    this.isQRCode = true;
  }
  getCurrentDayFormatted(): string {
    const date = new Date(new Date());
    return `${date.getFullYear()}-${((date.getMonth() + 1) <= 9) ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1)}-${(date.getDate() <= 9) ? '0' : ''}${date.getDate()}`;
  }
  getPlatform(): 'Android' | 'IOS' | 'Web' {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

    if (/android/i.test(userAgent)) {
      return 'Android';
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
      return 'IOS';
    }

    return 'Web';
  }
  printPage() {
    window.print();
  }

}